module.exports = __webpack_public_path__ + "static/media/mask9.dd78b619.JPG";